var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.iconObject)?_c('fa-icon',_vm._b({class:_vm.className,style:(_vm.customStyle),attrs:{"icon":_vm.iconObject}},'fa-icon',_vm.$attrs,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }